import { css } from '@emotion/react'
import { Button, Icon, Text } from 'bold-ui'
import { useState } from 'react'

import { RelatorioInconsistenciaModal } from './RelatorioInconsistenciaModal'

export const GerarRelatorioInconsistenciaButton = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const classes = styles()

  return (
    <>
      <Button kind='primary' onClick={() => setIsOpen(true)} style={classes.relatorioInconsistenciaButton}>
        <Icon icon='fileWithItemsOutline' style={classes.relatorioInconsistenciaIcon} />
        <Text color='inherit'>Gerar relatório de inconsistências</Text>
      </Button>
      {isOpen && <RelatorioInconsistenciaModal onClose={() => setIsOpen(false)} />}
    </>
  )
}

const styles = () => ({
  relatorioInconsistenciaButton: css`
    padding-left: 1rem;
    padding-right: 1rem;
  `,
  relatorioInconsistenciaIcon: css`
    margin-right: 0.5rem;
  `,
})
